//import { Link } from 'react-router-dom'

export default function Footer() {
  // const footerLinks = [
  //   { name: 'Home', url: '/' },
  //   { name: 'About Us', url: '/about' },
  //   { name: 'Clients', url: '/clients' },
  //   { name: 'FAQs', url: '/faq' },
  //   { name: 'Contact Us', url: '/contact' },
  //   { name: 'Site Map', url: '/sitemap' },
  //   { name: 'Privacy Policy', url: '/privacy' },
  // ]

  return (
    <footer className="app-footer shrink-0">
      <div className="container-fluid">
        <div className="row align-items-center g-0">
          <div className="col-12 text-end">
            <div>
              ©
              <span>{new Date().getFullYear()}</span>
              {" "}
              vccipl.com All Rights Reserved. Powered by {" "} 
              <span
                onClick={() => window.open("https://www.inooga.com", "_blank")}
                style={{
                  color: "#f9fafa",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                INOOGA
              </span>
            </div>
          </div>

          {/* <div className="col-md-6 text-center text-md-end">
            {footerLinks.map((link, index) => (
              <span key={link.url}>
                <Link to={link.url}>{link.name}</Link>
                {index !== footerLinks.length - 1 && (
                  <span className="app-footer__divider mx-1">|</span>
                )}
              </span>
            ))}
          </div> */}
        </div>
      </div>
    </footer>
  )
}
